import React, { useState } from 'react';

function Mean(props) {
  return (
    <div style={{marginLeft: '3%'}}>
      <h1>Mean</h1>
      <div>{props.mean}</div>
    </div>
  )
}
function Mode(props) {
  return (
    <div style={{marginLeft: '3%'}}>
      <h1>Mode</h1>
      <div>{props.mode}</div>
    </div>
  )
}
function Median(props) {
  return (
    <div style={{marginLeft: '3%'}}>
      <h1>Median</h1>
      <div>{props.median}</div>
    </div>
  )
}
function StandardDeviation(props) {
  return (
    <div style={{marginLeft: '3%'}}>
      <h1>Standard Deviation</h1>
      <div>{props.sd}</div>
    </div>
  )
}
function calculateMean(xToY) {
  let s = 0, c = 0;
  for (const x in xToY) {
    s += xToY[x] * x;
    c += xToY[x];
  }
  return c == 0 ? 0 : s / c;
}
function calculateMode(xToY) {
  let maxVal = 0, maxFreq = 0;
  for (const x in xToY) {
    if (xToY[x] > maxFreq) {
      maxFreq = xToY[x];
      maxVal = x;
    }
  }
  return maxVal;
}
function calculateMedian(xToY) {
  let list = [];
  for (const x in xToY) {
    for (let i = 0; i < xToY[x]; i++) list.push(x);
  }
  return !list.length ? 0 : list[Math.floor(list.length / 2)];
}
function calculateStandardDeviation(xToY) {
  let list = [];
  for (const x in xToY) {
    for (let i = 0; i < xToY[x]; i++) list.push(x);
  }
  let sigma = 0;
  let mean = calculateMean(xToY);
  for (let i = 0; i < list.length; i++) {
    sigma += (list[i] - mean) ** 2;
  }
  let res = Math.sqrt(sigma / list.length - 1);
  return isNaN(res) ? 0 : res;
}
function Info(props) {
  const me = calculateMean(props.allPoints);
  const mo = calculateMode(props.allPoints);
  const med = calculateMedian(props.allPoints);
  const sd = calculateStandardDeviation(props.allPoints);
  return (
    <div style={{border: 'solid', height: '80%', marginRight: '5%', position: 'relative', top: '30px', display: 'flex', flexDirection: 'column'}}>
        <Mean mean={me}/>
        <Median median={med}/>
        <Mode mode={mo}/>
        <StandardDeviation sd={sd}/>
    </div>
  )
}

export default Info